import type { UploadItem } from "./types";

export function isUploadTaskCompleted(task: Pick<UploadItem, "status">) {
  return task.status === "success" || task.status === "warning" || task.status === "error";
}
